import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
  InputOTPSeparator,
} from "@/components/ui/input-otp";

interface PinEntryDialogProps {
  open: boolean;
  onPinVerified: () => void;
  onOpenChange: (open: boolean) => void;
}

const HARDCODED_PIN = "445544";

export const PinEntryDialog: React.FC<PinEntryDialogProps> = ({
  open,
  onPinVerified,
  onOpenChange,
}) => {
  const [pin, setPin] = React.useState("");
  const [error, setError] = React.useState("");

  const handleSubmit = React.useCallback((currentPin: string) => {
    if (currentPin === HARDCODED_PIN) {
      onPinVerified();
      setPin("");
      setError("");
    } else {
      setError("Invalid PIN. Please try again.");
      // Optionally clear the pin for another attempt after a short delay or immediately
      // setPin("");
    }
  }, [onPinVerified]);

  const handlePinChange = (newPin: string) => {
    setPin(newPin);
    setError("");
    if (newPin.length === 6) {
      handleSubmit(newPin);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Enter PIN</DialogTitle>
          <DialogDescription>
            Enter the 6-digit PIN to access settings. It will auto-submit.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center space-y-4 py-4">
          <InputOTP maxLength={6} value={pin} onChange={handlePinChange}>
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
            </InputOTPGroup>
            <InputOTPSeparator />
            <InputOTPGroup>
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
          {error && <p className="text-sm font-medium text-status-danger">{error}</p>}
        </div>
        {/* Footer can be removed or left empty if no other buttons are needed */}
        <DialogFooter className="sm:justify-center pt-2">
            {/* Intentionally empty or add a cancel button if desired */}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
